import { Button, Grid, withStyles } from "@material-ui/core";
import ReceivingHours from "./ReceivingHours";
import { useState } from "react";
import { ToggleRenderer } from "../../../../../dataGrid/cellRenderer";
import { weekday } from "../../../../Dispatch/RouteExecution/Pickups/PickupManagement/ShipperInfo/utils";

const styles = (theme) => ({
  weekendContainer: {
    border: `1px solid ${theme.AppBGColor}`,
    display: 'flex',
    alignItems: 'center',
    maxWidth: '158px',
    paddingLeft: '10px',
    borderRadius: '4px',
    float: 'right'
  },
  resetButton: {
    fontSize: theme.textFontSize,
    color: theme.error,
    float: 'right',
    textTransform: 'uppercase'
  },
  toggleText: {
    display: 'inline-block',
    fontSize: theme.textFontSize,
    color: theme.iconColor
  }
});

const ReceivingHoursRenderer = ({
  receivingHours,
  updateHours,
  errorInfo,
  resetToDefaultHours,
  activeForm,
  classes,
  defaultHours,
}) => {
  const [isWeekendIncluded, setWeekendDelivery] = useState(
    receivingHours.hasOwnProperty(weekday[6])
  );
  const errorFieldName =
    activeForm === "delivery" ? "receivingHours" : "shippingHours";
  const onToggleIncludeWeekend = () => {
    if (isWeekendIncluded) {
      delete receivingHours[weekday[6]];
      delete receivingHours[weekday[7]];
    } else {
      receivingHours[weekday[6]] = [defaultHours];
      receivingHours[weekday[7]] = [defaultHours];
    }
    setWeekendDelivery(prevState => !prevState)
  }
  return (
    <div>
      <div className={classes.weekendContainer}>
        <div className={classes.toggleText}>Include weekend</div>
        <ToggleRenderer
          value={isWeekendIncluded}
          onChange={onToggleIncludeWeekend}
        />
      </div>
      <div>
        <Grid container spacing={16}>
          <Grid container item xs={12} spacing={16}>
            {Object.keys(receivingHours).map((day, index) => (
              <Grid item xs={4} key={day}>
                <ReceivingHours
                  dayName={day}
                  hours={receivingHours[day]}
                  updateHours={updateHours}
                  errors={errorInfo?.[errorFieldName]?.[day]}
                  dayIndex={index}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </div>
      <Grid item xs={12}>
        <Button
          id="resetToDefaultHours"
          onClick={resetToDefaultHours}
          variant="text"
          classes={{
            root: classes.resetButton,
          }}
          up
        >
          Reset Default Hours
        </Button>
      </Grid>
    </div>
  );
};

export default withStyles(styles)(ReceivingHoursRenderer);
